import styled from 'styled-components/macro';

import { TicketTextRegular } from 'components/common/fontElements';
import * as colors from 'components/common/colorConstants';

export const MessageTimeMarkerText = styled(TicketTextRegular)`
  font-size: 10px;
  white-space: normal;
  display: inline-block;
  color: ${colors.darkGray1};
  margin: 0px 0px 1px 5px;
`;

export const TimeDisparityIcon = styled.img`
  border-radius: 25px;
  width: 20px;
  height: 20px;
  padding-left: 3px;
`;
